import { Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrightsideUiModule } from '@brightside/brightside-ui';
import { MicroUiMoleculeModule } from '@micro-ui/molecule';
import { TranslateModule } from '@ngx-translate/core';
import { SharedDesktopModule } from '@brightside-web/shared/desktop';

@Component({
    selector: 'brightside-web-onboarding-welcome',
    imports: [CommonModule, BrightsideUiModule, MicroUiMoleculeModule, TranslateModule, SharedDesktopModule],
    templateUrl: './onboarding-welcome.component.html',
    styleUrl: './onboarding-welcome.component.css'
})
export class OnboardingWelcomeComponent {
  @Output() advanceStep = new EventEmitter();
  advance() {
    this.advanceStep.emit(true)
  }
}
